import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Gallery from '../gallery/Gallery';
import { getContext } from './../../redux/helpers/getParams';


class GalleryContainer extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      gallery: [],
    };
  }

  render() {
    const { images } = this.props;
    const sortBy = getContext() === 'pro' ? 'fileName' : 'id';

    return (
      <Gallery images={orderBy(images, sortBy, 'asc')} />
    );
  }
}

GalleryContainer.defaultProps = {
  images: {},
  isLoading: 'loading',
};

GalleryContainer.propTypes = {
  images: PropTypes.object,
  isLoading: PropTypes.string,
};

export default connect(state => ({
  images: state.entities.images.byId,
  isLoading: state.entities.io.imagesLoaded,
}))(GalleryContainer);



// WEBPACK FOOTER //
// ./src/components/gallery-container/GalleryContainer.jsx